<script setup lang="ts">
import axios from 'axios'
import { ChevronRight } from 'lucide-vue-next'

import Socials from '@/components/Socials.vue'

import useUrl from '@/composables/url'

import type { Store, StoreUrl } from '@/views/contests/Components/types/global'

interface StoreUrlCategory {
  id: number
  slug: string
}

defineProps<{
  stores: Store[]
}>()

const route = useRoute()
const router = useRouter()

const categoriesIds = reactive<{ facebook: number | null; instagram: number | null }>({
  facebook: null,
  instagram: null
})

onMounted(() => {
  fetchData()
})
const fetchData = () => {
  axios.get<{ data: StoreUrlCategory[] }>('/store-url-categories').then((response) => {
    const categories = response.data.data
    categoriesIds.facebook = categories.find((category) => category.slug === 'facebook')?.id ?? null
    categoriesIds.instagram = categories.find((category) => category.slug === 'instagram')?.id ?? null
  })
}
const goToDetails = (store: Store) => {
  router.push({
    name: 'StoreEdit',
    params: { storeId: store.id },
    query: route.query.redirect_url
      ? {
          redirect_url: useUrl().formattedRedirectUrl(route.fullPath)
        }
      : undefined
  })
}
const hasFacebook = (store: Store) => {
  return store.urls?.some((url): url is StoreUrl => url?.storeUrlCategoryId === categoriesIds.facebook) ?? false
}
const hasInstagram = (store: Store) => {
  return store.urls?.some((url): url is StoreUrl => url?.storeUrlCategoryId === categoriesIds.instagram) ?? false
}
</script>

<template>
  <div class="inline-block min-w-full align-middle">
    <Card class="mt-6 gap-0 overflow-hidden p-0">
      <button
        v-for="(store, index) in stores"
        :key="store.id"
        type="button"
        class="flex w-full cursor-pointer items-center px-4 py-4 text-left transition-colors hover:bg-muted/50 sm:px-6"
        :class="index !== 0 && 'border-t border-border'"
        @click="goToDetails(store)"
      >
        <div class="min-w-0 flex-1 md:grid md:grid-cols-1 lg:grid-cols-4 gap-4">
          <div class="col-span-3 shrink-0 pr-2 text-sm font-medium text-foreground">
            {{ store.name }}
          </div>
          <Socials
            :has-facebook="hasFacebook(store)"
            :has-instagram="hasInstagram(store)"
            :has-google="store.googlePlaceId !== null"
          />
        </div>
        <ChevronRight class="h-5 w-5 text-muted-foreground" />
      </button>
    </Card>
  </div>
</template>
